import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { forkJoin, of } from "rxjs";
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";
import { LosService } from "src/app/_LOS/services/los.service";
import { formatDateForExcel } from "../../Shared/date-utils";
declare var $: any;

@Component({
  selector: "app-collection-follow-up",
  templateUrl: "./collection-follow-up.component.html",
  styleUrls: ["./collection-follow-up.component.scss"],
  standalone: false,
})
export class CollectionFollowUpComponent implements OnInit {
  showSpinner: boolean = false;
  ShowFilter: boolean = true;
  currentUser: any;
  BranchesList: any = [];
  ProductList: any = [];
  dataSource: any;
  CheckType: any;
  DueDateFrom: any;
  DueDateTo: any;
  SelectBranch: any = [];
  SelectProduct: any = [];
  collection_exec: any = "";
  SelectSourceType: any = [];
  SearchType: any = "0";
  AccCatDropdown: any[] = [];
  LoanAccountingCatId: any = "0";
  displayedColumns: string[] = [
    "Id",
    "Application_No",
    "LoanAcNo",
    "Product_Name",
    "Branch_Name",
    "CustomerName",
    "Customer_PhoneNo",
    "Last_Recv_Date",
    "Total_OverDUE_EMI__Amount",
    "OverDUE_EMI",
    "DPD_Days",
    "EMIType",
  ];
  JsonData: any[] = [];
  div_due_list: boolean = false;
  SlabId: any = "";
  SlabData: any[] = [];
  minDate: any;
  maxDate: any;
  selectedId: any;
  FyearId: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  leadSourceDropdown: any;
  partnerDropdown: any;
  LeadSourceName: any;
  SalesExecutiveData: any = [];
  CollectionExecutiveData: any = [];
  private _MasterService;
  branchDropdownSettings: any = {};
  productDropdownSettings: any = {};
  sourceTypeDropdownSettings: any = {};
  readonly partnerSourceTypes = ["Agent", "DSA", "Dealer"];
  readonly executiveSourceTypes = [
    "Sales Executive",
    "Telecaller Executive",
    "Marketing Executive",
  ];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private dataSharingService: DataSharingService,
    private lmsService: LmsService,
    private MasterService: MasterService,
    private reportsService: ReportsService,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private losService: LosService
  ) {
    this._MasterService = MasterService;
  }

  ngOnInit() {
    this.CheckType = "OD Cases";
    this.getLeadSourceDropdown();
    this.GetSalesExecutive();
    this.GetLoanAccCategoryDropdown();
    this.dataSharingService.HeaderTitle.next("Collection Follow Up");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getBranchesList();
    this.getProductDropdown();
    this.getCollectionExecutive();

    this.getSlabsList("NPA");
    this.initializeDropdownSettings();

    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));

          if (this.maxDate >= new Date() && this.minDate <= new Date()) {
            this.DueDateTo = new Date();
            this.DueDateFrom = new Date();
          } else {
            this.DueDateFrom = this.maxDate;
            this.DueDateTo = this.maxDate;
          }
          this.dataSource = null;
        });
    });
  }

  GetLoanAccCategoryDropdown() {
    this.lmsService
      .Get_Loan_Accounting_Category_ForDropdown({ ProductId: 0 })
      .subscribe((res: any) => {
        this.AccCatDropdown = JSON.parse(JSON.stringify(res));
      });
  }

  initializeDropdownSettings() {
    this.branchDropdownSettings = {
      singleSelection: false,
      idField: "BranchId",
      textField: "Branch_Name",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: this.ShowFilter,
      itemsShowLimit: 1,
    };

    this.productDropdownSettings = {
      singleSelection: false,
      idField: "ProductId",
      textField: "Product",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: this.ShowFilter,
      itemsShowLimit: 1,
    };

    this.sourceTypeDropdownSettings = {
      singleSelection: false,
      idField: "Lead_Source",
      textField: "Lead_Source_DisplayName",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: this.ShowFilter,
      itemsShowLimit: 1,
    };
  }

  getSelectedIds(items: any[], key: string): string {
    return items?.map((item) => item[key]).join(",") || "";
  }

  getSelectedSourceTypes(): string[] {
    return this.SelectSourceType?.map((item) => item.Lead_Source) || [];
  }

  shouldShowLeadSourceName(): boolean {
    const selectedSourceTypes = this.getSelectedSourceTypes();
    return (
      selectedSourceTypes.some((type) =>
        this.partnerSourceTypes.includes(type)
      ) ||
      selectedSourceTypes.some((type) =>
        this.executiveSourceTypes.includes(type)
      )
    );
  }

  onBranchSelectionChange() {
    setTimeout(() => {
      this.BranchesList = [
        ...this.SelectBranch,
        ...this.BranchesList.filter(
          (item: any) =>
            !this.SelectBranch.some(
              (s: any) => s.BranchId === item.BranchId
            )
        ),
      ];
    }, 0);
    this.GetSalesExecutive();
    this.Get_PartnerForDropdown();
  }

  onProductSelectionChange() {
    setTimeout(() => {
      this.ProductList = [
        ...this.SelectProduct,
        ...this.ProductList.filter(
          (item: any) =>
            !this.SelectProduct.some(
              (s: any) => s.ProductId === item.ProductId
            )
        ),
      ];
    }, 0);
    this.GetSalesExecutive();
  }

  onSourceTypeSelectionChange() {
    setTimeout(() => {
      this.leadSourceDropdown = [
        ...this.SelectSourceType,
        ...this.leadSourceDropdown.filter(
          (item: any) =>
            !this.SelectSourceType.some(
              (s: any) => s.Lead_Source === item.Lead_Source
            )
        ),
      ];
    }, 0);
    this.Get_PartnerForDropdown();
  }

  getLeadSourceDropdown() {
    this.showSpinner = true;
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
      this.showSpinner = false;
    });
  }

  Get_PartnerForDropdown() {
    const selectedSourceTypes = this.getSelectedSourceTypes();
    const selectedPartnerTypes = selectedSourceTypes.filter((type) =>
      this.partnerSourceTypes.includes(type)
    );
    const hasExecutiveSourceType = selectedSourceTypes.some((type) =>
      this.executiveSourceTypes.includes(type)
    );

    if (!selectedSourceTypes.length) {
      this.partnerDropdown = [];
      this.LeadSourceName = "";
      return;
    }

    const dropdownRequests = selectedPartnerTypes.length
      ? selectedPartnerTypes.map((partnerType) =>
          this.losService.Get_Partner_ForDropdown_Multiselect({
            PartnerType: partnerType,
            branchId:
              this.getSelectedIds(this.SelectBranch, "BranchId") || "0",
          })
        )
      : [of([])];

    forkJoin(dropdownRequests).subscribe((responses: any[]) => {
      const mergedPartnerDropdown = [];
      const partnerMap = new Map();

      responses.forEach((response: any[]) => {
        response.forEach((partner: any) => {
          if (!partnerMap.has(partner.PartnerId)) {
            partnerMap.set(partner.PartnerId, true);
            mergedPartnerDropdown.push(partner);
          }
        });
      });

      if (hasExecutiveSourceType) {
        this.SalesExecutiveData.forEach((obj: any) => {
          if (!partnerMap.has(obj.EmpId)) {
            partnerMap.set(obj.EmpId, true);
            mergedPartnerDropdown.push({
              PartnerId: obj.EmpId,
              Partner_Name: obj.EmpName,
            });
          }
        });
      }

      this.partnerDropdown = mergedPartnerDropdown;
      this.LeadSourceName = this.partnerDropdown.length ? 0 : "";
    });
  }

  GetSalesExecutive() {
    this.losService
      .getEmployeeDropdownMultiselect({
        BranchId:
          this.getSelectedIds(this.SelectBranch, "BranchId") || "0",
        ProcessId: 1,
        ProductId:
          this.getSelectedIds(this.SelectProduct, "ProductId") || "0",
      })
      .subscribe((res: any) => {
        this.SalesExecutiveData = res;
        this.Get_PartnerForDropdown();
      });
  }

  getSlabsList(Slab_Type) {
    this._MasterService.Get__Slab_dropdown({
      Type: Slab_Type,
      LoginUserId: this.currentUser.userId,
    }).subscribe((result) => {
      this.SlabData = JSON.parse(JSON.stringify(result));
    });
  }

  getProductDropdown() {
    this._MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
      });
  }

  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  getCollectionExecutive() {
    this.lmsService
      .Get_Lms_CollectionExecutive({ Branch_Id: 0 })
      .subscribe((result) => {
        this.CollectionExecutiveData = JSON.parse(JSON.stringify(result));
      });
  }

  onSearchDueList() {
    this.showSpinner = true;
    let _finalData = {
      Search: {
        DueUpto: this.DueDateFrom,
        LoginUserId: this.currentUser.userId,
        ReceiptUpTo: this.DueDateTo,
        Type: this.CheckType,
        BranchId: this.getSelectedIds(this.SelectBranch, "BranchId"),
        ProductId: this.getSelectedIds(this.SelectProduct, "ProductId"),
        CollectionExecutive: this.collection_exec,
        SourceType:
          this.getSelectedIds(this.SelectSourceType, "Lead_Source") || "",
        SourceId: this.LeadSourceName || 0,
        slabId: this.SlabId,
        SearchType: Number(this.SearchType),
        LoanAccountingCatId: Number(this.LoanAccountingCatId),
      },
    };

    console.log("Request For COLLECTION FOLLOW UP-FinalDATA", _finalData);
    this.reportsService
      .Get_Short_DUELIST({ JSON: JSON.stringify(_finalData) })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.JsonData = JSON.parse(JSON.stringify(res));
          this.dataSource = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.dataSource.sort = this.sort;
          this.showSpinner = false;
          this.dataSource.paginator = this.paginator;
          this.div_due_list = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No data found",
        ...this.configSuccess,
      });
          this.dataSource = null;
          this.showSpinner = false;
        }
      });
  }

  totaltypewise(type) {
    if (this.dataSource != null) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i][type]);
      }
      return sum != 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }

  formatDateForExcel = formatDateForExcel;

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public highlightRow(row) {
    this.selectedId = row.Loan_Id;
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "export-collection-followup"
    ) as HTMLTableElement;
    const worksheetName = "COLLECTION FOLLOW UP";
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const dueUptoStr = moment(this.DueDateTo).format("DD-MM-YYYY");
    const downloadLink = document.createElement("a");

    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = `${worksheetName}_${dueUptoStr}.xls`;
    downloadLink.click();
  }
}
